const developmentSiteKey = '1x00000000000000000000AA';

export const turnstileSiteKey =
  import.meta.env.VITE_TURNSTILE_SITE_KEY || (import.meta.env.DEV ? developmentSiteKey : '');
